import fetch from "../fetch";

export default ({ values, dealCode }) => {
  return fetch({
    path: dealCode ? `/cmbs/deals/${dealCode}` : "/cmbs/deals",
    method: dealCode ? "PUT" : "POST",
    data: values
  });
};
